import React, { Fragment, useState, useEffect } from 'react';
import styled from '@emotion/styled';
import { useDispatch } from 'react-redux';

import SpinnerBlock from '../../common/SpinnerBlock';
import EditOrLock from './common/EditOrLock';

import { showModal } from '../../../actions/modal';
import { getYandexStoreImageMin } from '../../../helpers';
import { useAutoTranslation } from '../../../helpers/useAutoTranslation';

const Wrapper = styled('div')`
  position: relative;
  padding-left: 0;
  padding-right: 0;
  box-shadow: none;
  border: 1px solid #ebebeb;
  > div {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
    padding-bottom: 10px;
    &:last-child {
      padding-bottom: 0;
    }
  }
  .card-title {
    padding-top: 3px;
    padding-bottom: 13px;
    h4 {
      font-size: 16px;
    }
  }

  .attachments {
    .attachment-comment {
      font-weight: 400;
      font-size: 10px;
      line-height: 12px;
      color: #a7a8ac;
    }
    h4 {
      font-weight: bold;
      font-size: 12px;
      line-height: 16px;
      color: #abb2c7;
      margin: 0 0 8px;
    }
    ul {
      padding: 0;
      margin: 0;
      li {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 10px;
        .attachment-left {
          display: flex;
          width: 65%;
        }
        .image-block {
          margin-top: 5px;
          height: 32px;
          width: 32px;
          background-repeat: no-repeat;
          background-position: center center;
          background-size: contain;
          border-radius: 3px;
          margin-right: 8px;
          flex: none;
        }
        .quantity {
          font-size: 12px;
          line-height: 16px;
          color: #6e768e;
          flex: none;
          margin-left: 20px;
        }
        .attachment-info {
          max-width: 100%;
          h5 {
            font-weight: 500;
            font-size: 12px;
            line-height: 16px;
            color: #6e768e;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            max-width: 100%;
            margin: 4px 0 4px;
          }
          .
        }
      }
    }
  }

  @media (max-width: 400px) {
    .attachments ul li .attachment-info h5 {
      width: 150px;
    }
  }
`;

const AdAttachmentsBlock = (props) => {
  const { currentOrder, haveProducts, handleEditOrder } = props;

  const { adAttachments } = currentOrder;

  const [cachedAttachments, setCachedAttachments] = useState([]);

  const { t } = useAutoTranslation();

  useEffect(() => {
    setCachedAttachments(adAttachments);
  }, [adAttachments]);

  const dispatch = useDispatch();

  const handleEditAdditionalAttachments = (attachments) => {
    dispatch(
      showModal('EditAdditionalAttachments', {
        attachments,
        type: 'order',
        handleAddAdditionalAttachments,
        handleEditOrder,
        currentOrder,
        resetCachedAttachments,
      }),
    );
  };

  const handleAddAdditionalAttachments = (attachments) => {
    dispatch(
      showModal('AddingAdditionalAttachment', {
        items: attachments,
        type: 'order',
        resetCachedAttachments,
        handleUpdateAttachmentsItems: (attachments) => {
          setCachedAttachments(attachments);
          handleEditAdditionalAttachments(attachments);
        },
      }),
    );
  };

  const resetCachedAttachments = () => {
    setCachedAttachments(adAttachments);
  };

  return (
    <Wrapper className={`card-box ${!haveProducts ? 'disabled' : ''}`}>
      <div style={{ display: 'flex' }} className="card-title">
        <h4 className="header-title">{t('Доп. вложения')}</h4>
        <EditOrLock
          permissions={currentOrder.permissionList}
          permissionKey="DELIVERY_EDITABLE"
          action={() => handleEditAdditionalAttachments(cachedAttachments)}
        />
      </div>
      <div className="border-top" />
      {adAttachments?.length ? (
        <div className="attachments">
          <h4>{t('ТОВАРЫ')}</h4>
          <ul>
            {adAttachments.map((attachment) => (
              <li className="attachment" key={attachment.productId}>
                <div className="attachment-left">
                  <div
                    className="image-block"
                    style={{
                      backgroundImage: `url(${getYandexStoreImageMin(attachment.img, 100)})`,
                    }}
                  />
                  <div className="attachment-info">
                    <h5>{attachment.shortName}</h5>
                    <p className="attachment-comment">{attachment.comment}</p>
                  </div>
                </div>
                <div className="quantity">{attachment.quantity} шт.</div>
              </li>
            ))}
          </ul>
        </div>
      ) : (
        <div className="mock-title">{t('Нет доп. вложений')}</div>
      )}
    </Wrapper>
  );
};

export default AdAttachmentsBlock;
